<template lang="pug">
    .drawer-container
        el-button(
            type="info"
            icon="el-icon-fa-plus fas"
            size="large"
            @click="openStockDrawer('increase')"
        ) {{ $t('Article stock') }}
        el-button(
            type="info"
            icon="el-icon-fa-minus fas"
            size="large"
            @click="openStockDrawer('decrease')"
        ) {{ $t('Article stock') }}
        el-drawer.update-stock-drawer(
            :title="drawer.title"
            :visible.sync="drawer.visibility"
            :modal="true"
            size="50%"
            @close="$emit('focus-search')"
            @closed="resetStockDrawer"
        )
            el-tabs.tabs(@tab-click="changeUpdateStockDrawerTab")
                el-tab-pane(:label="$t('update stock quantities')")
                    .drawer-body(
                        ref="stockDrawerBody"
                        @scroll="handleStockDrawerScroll"
                        v-dragscroll
                    )
                        .alert.danger(v-if="!stockOptions || !stockOptions.length")
                            p {{ $t('No stock options available') }}
                        el-form(
                            v-else
                            ref="form"
                            label-position="top"
                            :model="drawer.form"
                            :rules="drawer.rules"
                            @submit.prevent="submit"
                        )
                            .flex-row
                                el-form-item.grow(
                                    v-if="drawer.form.individually"
                                    :label="$t('SKU')"
                                    prop="sku"
                                )
                                    el-input(
                                        ref="autofocus"
                                        v-model="drawer.form.sku"
                                        @keyup.enter.native="addSku"
                                        @input="validate"
                                        :disabled="drawer.locked"
                                    )
                                el-form-item.grow(
                                    v-else
                                    :label="$t('protocol name')"
                                    prop="protocolName"
                                )
                                    el-input(
                                        ref="autofocus"
                                        v-model="drawer.form.protocolName"
                                    )
                                el-form-item(:label="$t('Stock')" prop="stock")
                                    el-select(
                                        v-model="drawer.form.stock"
                                        :disabled="stockOptions.length <= 1"
                                        placeholder=""
                                        valueKey="id"
                                    )
                                        el-option(
                                            v-for="stock in stockOptions"
                                            :key="stock.id"
                                            :label="stock.name"
                                            :value="stock"
                                        )
                                el-form-item(label=" " prop="action")
                                    //- :disabled="!drawer.form.sku"
                                    el-button(
                                        v-if="drawer.form.action == 'increase'"
                                        type="success"
                                        icon="el-icon-fa-plus fas"
                                        :disabled="drawer.locked"
                                        @click="submit"
                                    ) {{ $t('Increase by one') }}
                                    el-button(
                                        v-else-if="drawer.form.action == 'decrease'"
                                        type="danger"
                                        icon="el-icon-fa-minus fas"
                                        :disabled="drawer.locked"
                                        @click="submit"
                                    ) {{ $t('Decrease by one') }}
                            .flex-row
                                el-form-item.grow(
                                    v-if="!drawer.form.individually"
                                    :label="$t('SKUs')"
                                    prop="sku"
                                )
                                    el-input(
                                        v-model="drawer.form.sku"
                                        type="textarea"
                                        @input="validate"
                                        :disabled="drawer.locked"
                                        :autosize="{ minRows: 5, maxRows: 40 }"
                                    )
                            .flex-row
                                //- el-switch(
                                //-     :active-text="$t('Submit individually')"
                                //-     inactive-color="#ff4949"
                                //-     v-model="drawer.form.individually"
                                //-     @change="handleIndividuallySwitch"
                                //- )

                                //- el-radio-group(v-model="drawer.form.individually" @change="resetValidation")
                                //-     el-radio-button(name="individually" :label="false") {{ $t('multiple items (e.g. inventory)') }}
                                //-     el-radio-button(name="individually" :label="true") {{ $t('single item') }}

                            .logs(v-loading="drawer.loading")
                                transition(name="slide-decent-vertical")
                                    .alert.success(v-if="drawer.articles.length") {{ $t('The following inventory has been updated successfully') }}
                                .article(v-for="article in drawer.articles")
                                    .row
                                        nobr.nr {{ article.product.nr }}
                                        nobr.name {{ article.name || article.product.name }}
                                        nobr.price {{ article.price.value | moneyFormat(currencyCode) }}
                                    .row.properties
                                        property-pivot-values(
                                            v-for="pivot in article.propertyPivots"
                                            :key="pivot.property.id"
                                            :property="pivot.property"
                                            :value-options="[pivot.valueOption]"
                                        )
                                    .row
                                        nobr.sku
                                            label {{ $t('SKU') }}:
                                            span.value {{ article.sku }}
                                        //- nobr.stock
                                        //-     label {{ $t('Stock') }}:
                                        //-     span.value {{ drawer.form.stock.name }}
                                        nobr.qty
                                            label {{ $t('Quantity') }}:
                                            span.value {{ article.stocks.find(el => el.id == drawer.form.stock.id).pivot.qty }}
                el-tab-pane(:label="$t('Protocols')" name="inventory-protocols" )
                    .drawer-body(v-loading="drawer.protocolsLoading" @scroll="handleDrawerScroll")
                        template(v-if="inventoryProtocols" )
                            template(v-if="!drawer.protocolsLoading && inventoryProtocols.items.length == 0")
                                p.label {{ $t('No PDF documents with inventory protocols present.') }}
                            table.striped.is-full-width
                                thead
                                    tr
                                        th(colspan="3" style="height: 5px")
                                tbody
                                    tr(v-for="item in inventoryProtocols.items")
                                        td.center.min
                                            .flex-row
                                                el-button.download-button(
                                                    circle
                                                    size="mini"
                                                    type="info"
                                                    icon="el-icon-fa-download fas"
                                                    @click.stop.prevent="download(item)"
                                                )
                                                el-button.print-button(
                                                    circle
                                                    size="mini"
                                                    type="info"
                                                    icon="el-icon-fa-print fas"
                                                    @click.stop.prevent="print(item)"
                                                )
                                        td {{ item.name }}
                                        td.min {{ dateFormat(item.created_at) }}

            //- .drawer-footer
</template>

<i18n>
{
    "de": {
        "Stock": "Lager",
        "Quantity": "Anzahl",
        "Article stock": "Artikelbestand",
        "Article not found": "Artikel konnte nicht gefunden werden",
        "Submit individually": "Einzeln erfassen",
        "single item": "einzelner Artikel",
        "multiple items (e.g. inventory)": "mehrere Artikel (z.B. Inventur)",
        "No stock options available": "Keine Lageroptionen verfügbar",
        "The following inventory has been updated successfully": "Der folgende Bestand wurde erfolgreich aktualisiert",
        "Increase by one": "Erhöhe um eins",
        "Decrease by one": "Verringere um eins",
        "update stock quantities": "Bestand verändern",
        "Protocols": "Protokolle Bestandveränderung",
        "protocol name": "Protokoll-Name",
        "No PDF documents with inventory protocols present.": "Keine PDF-Dokumente mit Bestandsprotokollen verfügbar.",
        "PDF generation started in background, you can check back later.": "PDF-Generierung wurde im Hintergrund gestartet. Sie können die Datei unter 'Protokolle Bestandveränderung' abrufen, sobald sie erstellt wurde.",
        "The following SKUs could not be found:": "Folgende SKUs konnten nicht gefunden werden: "
    }
}
</i18n>

<script>
import _ from 'lodash';
import uniqid from 'uniqid';

import StockApi from '@/extensions/shop/pointOfSale/store/api/stock';
import ArticleApi from '@/extensions/shop/store/api/article';
import FileApi from '@/store/api/cms/file';
import AuthApi from '@/store/api/system/auth';
import { useAuthStore, useSetupStore, usePosSetupStore, usePosCartStore } from '@/stores'

import PropertyPivotValues from '@/extensions/shop/components/Products/PropertyPivotValues';

import { timestamp2date } from '@/filters';
import echo from '@/echo';

export default {
    name: 'UpdateStockDrawer',
    data() {
        return {
            drawer: {
                title: this.$t('Article stock'),
                visibility: false,
                loading: false,
                locked: false,
                articles: [],
                form: {
                    action: undefined,
                    individually: false,
                    stock: undefined,
                    sku: undefined,
                    skus: [],
                    protocolName: "",
                    isValid: false
                },
                rules: {
                    // action: 'required',
                    stock: 'required',
                    sku: 'required',
                    protocolName: 'required'
                },
                protocolsLoading: false,
            },
            inventoryProtocols: {
                items: [],
                currentPage: 1,
                lastPage: 0
            },
            // Held so the handler can be unbound again by reference - see
            // listenForInventoryProtocols().
            inventoryProtocolListener: null,
        };
    },
    components: {
        PropertyPivotValues,
    },
    beforeDestroy() {
        this.stopListeningForInventoryProtocols();
    },
    computed: {
        posSetupStore() {
            return usePosSetupStore();
        },
        posCartStore() {
            return usePosCartStore();
        },
        activeCms() {
            return useSetupStore().activeCms
        },
        currencyCode() {
            // ignore selected customer .. not important for stock changes
            // return _.get(this.purchaser, 'customer.customerGroup.currency.iso4217')
            return _.get(this.activePointOfSale, 'customerGroup.currency.iso4217')
                || _.get(this.activeCms, 'shop.defaultCustomerGroup.currency.iso4217')
        },
        currencySymbol() {
            // ignore selected customer .. not important for stock changes
            // return _.get(this.purchaser, 'customer.customerGroup.currency.sign')
            return _.get(this.activePointOfSale, 'customerGroup.currency.sign')
                || _.get(this.activeCms, 'shop.defaultCustomerGroup.currency.sign')
        },

        // currencyCode() {
        //     return _.get(this.currency, 'iso4217') || 'EUR'
        // },
        // currencySymbol() {
        //     return _.get(this.currency, 'sign') || '€'
        // },

        // customerPricesFeatureEnabled() {
        //     let features = _.get(this.activeCms, 'config.template.features') || [];
        //     return !!features.find(el => el === 'pos:customer-prices');
        // },

        stockOptions() {
            return this.activePointOfSale.stocks || []
        },
        rules() {
            if (this.drawer.form.individually) {
                let copy = _.clone(this.drawer.rules)
                delete copy.protocolName
                return copy
            }
            else {
                return this.drawer.rules
            }
        },
        user() {
            return useAuthStore().user;
        },
        purchaser() {
            return this.posCartStore.purchaser;
        },
        activePointOfSale() {
            return this.posSetupStore.activePointOfSale;
        },
        currency() {
            return this.posSetupStore.currency;
        },
        options() {
            return this.posSetupStore.options;
        },
    },
    methods: {
        resetValidation() {
            const save = this.drawer.form.action
            this.$refs.form.resetFields()
            drawer.form.action = save
        },
        validate() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    this.drawer.form.isValid = true
                } else {
                    this.drawer.form.isValid = false
                }
            })
        },
        openStockDrawer(action) {
            // this.drawer.loading = true;
            this.drawer.visibility = true;

            this.drawer.form.action = action
            if (this.stockOptions && this.stockOptions.length) this.drawer.form.stock = this.stockOptions[0]

            this.$nextTick(() => {
                this.$refs.autofocus.focus();
            });

            this.$emit('blur-search');
            this.updateAutofocusSearchInput(false);

            // TODO
            // this.drawer.loading = false;
        },
        changeUpdateStockDrawerTab(tab) {
            if (tab.name == 'inventory-protocols') {
                this.resetState();
                this.drawer.protocolsLoading = true;
                this.listenForInventoryProtocols();

                this.loadNew(1)

            }
        },
        // Bound once. This runs on every switch to the protocols tab, and Echo appends a
        // handler per call - so three visits used to mean three reloads per event.
        listenForInventoryProtocols() {
            if (this.inventoryProtocolListener || !this.user || !this.user.id) return;

            this.inventoryProtocolListener = data => {
                // The channel is per user, not per CMS: an account administering several
                // of them would reload this list for a protocol rendered in a completely
                // different CMS.
                if (!useSetupStore().belongsToActiveCms(_.get(data, 'cms_id'))) return;

                this.resetState();

                this.drawer.protocolsLoading = true;
                this.loadNew(1);
            };

            echo.client.private('user.' + this.user.id)
                .listen('.inventory-protocol:created', this.inventoryProtocolListener);
        },
        // Unbind by reference, never `leave()` and never a bare stopListening(): this
        // channel is shared with the setup store's global notification listeners, and
        // both of those would tear those down along with this one.
        stopListeningForInventoryProtocols() {
            if (!this.inventoryProtocolListener) return;

            if (echo.client && this.user && this.user.id) {
                echo.client.private('user.' + this.user.id)
                    .stopListening('.inventory-protocol:created', this.inventoryProtocolListener);
            }

            this.inventoryProtocolListener = null;
        },
        resetState() {
            this.inventoryProtocols.items = []
            this.inventoryProtocols.currentPage = 1;
            this.inventoryProtocols.lastPage = 0;
        },
        download(item) {
            const storageRoute = _.trim(
                `${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PRIVATE_STORAGE_ROUTE}`,
                '/'
            );

            const token = AuthApi.getToken()

            const table = 'files';
            const link = `${storageRoute}/${table}/${item.id}/${encodeURIComponent(item.name)}?download&token=${token}`;

            let element = document.createElement('a');
            element.setAttribute('href', link);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();
            document.body.removeChild(element);
        },
        print(item) {
            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PRIVATE_STORAGE_ROUTE}`, '/')
            let table = 'files'

            // const file = this.cashReport.file
            const token = AuthApi.getToken()
            const printable = `${storageRoute}/${table}/${item.id}/${item.name}?token=${token}`

            printJS({
                printable,
                onLoadingEnd: () => {
                    // Don't reset state here - wait for print dialog
                },
                onError: () => {
                    this.printing = false;
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Could not print the cash report PDF!'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                },
                onPrintDialogClose: () => {
                    this.printing = false;
                }
            })
        },
        handleDrawerScroll(event) {
            const { target } = event;
            this.loadMoreIfNeeded(target)
        },
        loadMoreIfNeeded(target) {
            const currentPage = this.inventoryProtocols.currentPage;
            if (this.drawer.loading === false && this.inventoryProtocols.lastPage > currentPage) {

                let loadMore = false;
                const offset = 40;

                if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight - offset) {
                    loadMore = true;
                }

                if (loadMore) {
                    this.loadNew(currentPage + 1);
                }
            }
        },
        loadNew(page) {
            this.inventoryProtocols.currentPage = page;
            let obj = {
                pageInfo: {
                    perPage: 25,
                    currentPage: page,
                },
                filters: [
                    {
                        key: 'cms',
                        match: this.activeCms.id
                    },
                    // {
                    //     key: 'stock',
                    //     match: this.activePointOfSale.stocks[0].id
                    // },
                    {
                        key: 'type',
                        match: 'inventory-protocol'
                    }
                ],
            }

            const stocks = this.activePointOfSale.stocks || []
            if (stocks.length) {
                obj.filters.push({
                    key: 'stock',
                    match: stocks[0].id
                })
            }

            this.drawer.protocolsLoading = true;

            FileApi.fetchFilesPaginated(obj).then(data => {
                this.inventoryProtocols.lastPage = data.pageInfo.lastPage;
                this.drawer.protocolsLoading = false;
                this.inventoryProtocols.items.push(...data.items);
            }).catch((err) => reject(err)).finally(() => {
                this.drawer.protocolsLoading = false
            })
        },
        dateFormat(timestamp) {
            return timestamp2date(timestamp, this.$t('yyyy-MM-dd') + ', HH:mm')
        },
        handleStockDrawerScroll(event, cashFlowLogs) {
            // const { target } = event;
            // this.loadMoreCashFlowLogsIfNeeded(target, cashFlowLogs)
        },
        // loadMoreCashFlowLogsIfNeeded(target, cashFlowLogs) {
        //     if (! cashFlowLogs.pagination) return;

        //     if (Array.isArray(target) && target.length === 1) target = target[0]

        //     const currentPage = cashFlowLogs.pagination.pageInfo.currentPage;
        //     if (target && cashFlowLogs.pagination.loading !== true && cashFlowLogs.pagination.pageInfo.lastPage > currentPage) {

        //         let loadMore = false;
        //         // const offset = window.innerHeight * 0.8;
        //         const offset = window.innerHeight;
        //         if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight - offset) loadMore = true;

        //         if (loadMore) {
        //             this.$set(cashFlowLogs.pagination, 'loading', true);
        //             this.loadCashFlowLogsIntoDrawer(cashFlowLogs, currentPage + 1)
        //         }
        //     }
        // },
        // async loadCashFlowLogsIntoDrawer(cashFlowLogs, page = 1) {
        //     this.$set(cashFlowLogs.pagination.pageInfo, 'currentPage', page)

        //     const paginatedCashFlowLogs = await CashFlowLogApi.fetchCashFlowLogsPaginated(cashFlowLogs.pagination)
        //         .catch(err => {
        //             this.$notify.error({
        //                 title: this.$t('An error occurred!'),
        //                 iconClass: 'fas el-icon-fa-times',
        //                 position: 'bottom-left',
        //                 customClass: 'dark',
        //                 duration: 8000
        //             });

        //             console.error(err)
        //         })

        //     if (paginatedCashFlowLogs.items && paginatedCashFlowLogs.items.length) {
        //         if (page > 1) {
        //             cashFlowLogs.pagination.items = [...cashFlowLogs.pagination.items, ...paginatedCashFlowLogs.items]
        //         } else {
        //             cashFlowLogs.pagination = paginatedCashFlowLogs;
        //         }
        //     } else {
        //         this.$notify.error({
        //             title: this.$t('No more logs found'),
        //             iconClass: 'fas el-icon-fa-times',
        //             position: 'bottom-left',
        //             customClass: 'dark',
        //             duration: 8000
        //         });
        //     }

        //     this.$nextTick(() => {
        //         this.loadMoreCashFlowLogsIfNeeded(this.$refs[`cash-flow-logs-${cashFlowLogs.paymentMethod.service}`], cashFlowLogs)
        //     })

        //     cashFlowLogs.loading = false;
        //     this.$set(cashFlowLogs.pagination, 'loading', false);
        // },

        handleIndividuallySwitch() {
            this.$nextTick(() => {
                // this.$refs.form.resetFields()
                this.$refs.form.clearValidate()
                this.$refs.autofocus.focus();
            });
        },

        submit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    this.drawer.locked = true;
                    this.drawer.loading = true;
                    this.drawer.rules.sku = undefined

                    let skus = this.drawer.form.skus
                    if (!skus || !skus.length) {
                        skus = this.drawer.form.sku.split(/\r?\n|\r|\n/g).filter(value => value)
                    }
                    this.drawer.form.skus = []

                    const payload = {
                        uniqid: uniqid(),
                        action: this.drawer.form.action,
                        stock: this.drawer.form.stock,
                        pointOfSale: this.activePointOfSale,
                        skus,
                    }

                    if (!this.drawer.form.individually) payload.protocolName = this.drawer.form.protocolName;

                    const stock = await StockApi.updateStock(payload)
                        .catch(err => {
                            const { networkError, graphQLErrors } = err;
                            const code = _.get(graphQLErrors, '0.code');

                            if (code === 404) {
                                this.$notify.error({
                                    title: this.$t('Article not found'),
                                    iconClass: 'fas el-icon-fa-times',
                                    position: 'bottom-left',
                                    customClass: 'dark',
                                    duration: 8000
                                });
                            } else {
                                this.$notify.error({
                                    title: this.$t('An error occurred!'),
                                    iconClass: 'fas el-icon-fa-times',
                                    position: 'bottom-left',
                                    customClass: 'dark',
                                    duration: 8000
                                });
                            }

                            console.error(err)
                        })

                    this.drawer.locked = false;
                    this.drawer.rules.sku = 'required'
                    this.$nextTick(() => {
                        if (this.$refs.autofocus) this.$refs.autofocus.focus();
                    });

                    if (stock) {

                        if (!this.drawer.form.individually) {
                            this.$notify.info({
                                title: this.$t('PDF generation started in background, you can check back later.'),
                                iconClass: 'fas el-icon-fa-info-circle',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000,
                            })

                            if (stock.missingSkus && stock.missingSkus.length > 0) {
                                this.$notify.warning({
                                    title: this.$t('The following SKUs could not be found:') + stock.missingSkus,
                                    iconClass: 'fas el-icon-fa-xmark',
                                    position: 'bottom-right',
                                    customClass: 'dark',
                                    duration: 0
                                })
                            }
                        }

                        this.drawer.form.sku = ''
                        this.drawer.form.protocolName = ''
                        setTimeout(() => {
                            this.$refs.form.clearValidate()
                        }, 0);

                        // ignore selected customer .. not important for stock changes
                        // let mimicCustomer = this.purchaser.customer ? { id: this.purchaser.customer.id } : null
                        let mimicCustomer

                        const customerGroup = _.get(this.activePointOfSale, 'customerGroup')
                            || _.get(this.activeCms, 'shop.defaultCustomerGroup')
                        const address = _.get(this.activePointOfSale, 'address')
                        if (!mimicCustomer && customerGroup) {
                            mimicCustomer = {
                                id: null,
                                customerGroup,
                                member: { address },
                            }
                        }

                        let payload = { shop: parseInt(this.activeCms.shop.id), skus }
                        if (mimicCustomer) payload.mimicCustomer = mimicCustomer

                        let articles = await ArticleApi.fetchArticles(payload);

                        this.drawer.loading = false;

                        articles = [...this.drawer.articles, ...articles]
                        this.drawer.articles = [...new Map(articles.map(article => [article.id, article])).values()]
                            .sort((a, b) => {
                                const a_stock = a.stocks.find(el => el.id === this.drawer.form.stock.id)
                                const b_stock = b.stocks.find(el => el.id === this.drawer.form.stock.id)
                                if (a_stock && b_stock) return b_stock.pivot.updated_at - a_stock.pivot.updated_at
                                return null
                            })
                    } else {
                        this.drawer.loading = false;
                    }

                } else {
                    this.$notify.warning({
                        title: this.$t('Form is not valid!'),
                        message: this.$t('Correct your input and submit again.'),
                        iconClass: 'fas el-icon-fa-exclamation-circle',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                }
            });
        },
        // debouncedSubmit: _.debounce(function() { // function scope is needed here
        //     this.submit()
        // }, 500),
        addSku(event) {
            if (event.shiftKey || event.ctrlKey || event.altKey) {
                return false
            } else if (this.drawer.form.sku) {
                // console.log(this.drawer.form.sku.split(/\r?\n|\r|\n/g).filter(value => value))
                const skus = [...this.drawer.form.skus, ...this.drawer.form.sku.split(/\r?\n|\r|\n/g).filter(value => value)]
                this.drawer.form.skus = skus
                this.drawer.form.sku = ''
                // setTimeout(() => {
                //     // this.$refs.form.resetFields()
                //     this.$refs.form.clearValidate()
                // }, 0)
                this.drawer.rules.sku = undefined
                // this.debouncedSubmit()
                this.submit()
            } else {
                this.$refs.form.validate(() => { })
                // this.debouncedSubmit()
                this.submit()
            }
        },
        closeStockDrawer() {
            this.drawer.visibility = false;
        },
        resetStockDrawer() {
            this.drawer = {
                title: this.$t('Article stock'),
                visibility: false,
                loading: false,
                locked: false,
                type: undefined,
                articles: [],
                form: {
                    action: undefined,
                    individually: false,
                    stock: undefined,
                    sku: undefined,
                    skus: [],
                },
                rules: {
                    // action: 'required',
                    stock: 'required',
                    sku: 'required',
                    protocolName: 'required'
                },
            }

            setTimeout(() => {
                // this.$refs.form.resetFields()
                this.$refs.form.clearValidate()
            }, 0)

            this.updateAutofocusSearchInput(true);
            this.$emit('focus-search')
        },
        updateAutofocusSearchInput(value) {
            this.posSetupStore.updateAutofocusSearchInput(value);
        },
    },
};
</script>

<style lang="sass" scoped>
.update-stock-drawer
    .drawer-body
        flex-grow: 1
        overflow: auto
        padding: 0
        // padding: 20px
        // padding-top: 20px
        // padding-left: 0px
        // max-height: calc(100vh - 120px)
        max-height: calc(100vh - 100px)
        .el-form
            padding: 20px

    &::v-deep .el-loading-mask
        background-color: rgba(255, 255, 255, 0.6) !important

.flex-row
    display: flex
    gap: 1rem
    .grow
        flex-grow: 1

.el-textarea
    display: block
    &::v-deep textarea
        min-height: 36px !important
        padding: 6px 15px

.el-button
    margin: 0

.article
    flex-grow: 1
    min-width: 0
    padding: 6px 0
    &::v-deep label
        font-weight: bold
    .row
        display: flex
        gap: 0.5rem
        & + .row
            margin-top: 0.25rem
    .name
        flex-grow: 1
        min-width: 0
        white-space: nowrap
        overflow: hidden
        text-overflow: ellipsis
    .sku
        flex-grow: 1
    label + span.value:before
        content: ' '
    label
        font-style: italic
        &.small
            font-size: 0.8em

    & + .article
        margin-top: calc(1rem - 6px)
        padding-top: 1rem
        border-top: 1px solid darken($color-skeleton, 10%)

.drawer-spinner-container
    min-height: 54px

.tabs
    // margin-left: 20px
    flex-grow: 1
    &::v-deep
        .el-tabs__nav
            padding-left: 20px
        .el-tabs__active-bar
            margin-left: 20px
    .el-tab-pane
        min-height: 100%
        display: flex

.is-full-width
    width: 100%

table.striped
    border-collapse: collapse
    .first
        min-width: 400px
        font-weight: bold
    td
        padding: 5px 10px
        &.min
            width: 1px
            white-space: nowrap
        &:first-child
            padding-left: 20px
        &:last-child
            padding-right: 20px

.center
    text-align: center
</style>
